var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        { name: "show", rawName: "v-show", value: true, expression: "true" }
      ],
      staticClass: "flex sm10 md10"
    },
    [
      _c(
        "FormFieldsContainer",
        [
          !_vm.loading
            ? _c(
                "v-flex",
                { attrs: { layout: "", md12: "", sm12: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { layout: "", md12: "", sm12: "", wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { md3: "", sm3: "" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              disabled: _vm.isEdit || _vm.deshabilitar,
                              label: "Serie Número (Obligatorio)",
                              rules: [_vm.rules.serie],
                              clearable: !_vm.isEdit,
                              required: ""
                            },
                            on: { change: _vm.getTipoEquipos },
                            model: {
                              value: _vm.objParam.serienumero,
                              callback: function($$v) {
                                _vm.$set(_vm.objParam, "serienumero", $$v)
                              },
                              expression: "objParam.serienumero"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { md3: "", sm3: "" } },
                        [
                          _c("v-combobox", {
                            attrs: {
                              disabled:
                                _vm.disabledFiled.deviceList ||
                                _vm.deshabilitar,
                              items: _vm.deviceList,
                              label: "Tipo Equipo (Obligatorio)",
                              "item-text": "nombre",
                              "item-value": "id",
                              rules: [_vm.rules.equipo],
                              required: ""
                            },
                            on: { change: _vm.handleTipoEquipoSelected },
                            model: {
                              value: _vm.objParam.tipoeqid,
                              callback: function($$v) {
                                _vm.$set(_vm.objParam, "tipoeqid", $$v)
                              },
                              expression: "objParam.tipoeqid"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { md3: "", sm3: "" } },
                        [
                          _c("DatePicker", {
                            attrs: {
                              disabled:
                                _vm.disabledForm ||
                                _vm.isEdit ||
                                _vm.deshabilitar,
                              label: "Fecha Preparación"
                            },
                            model: {
                              value: _vm.objParam.serieactivafecha_alta,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.objParam,
                                  "serieactivafecha_alta",
                                  $$v
                                )
                              },
                              expression: "objParam.serieactivafecha_alta"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { md3: "", sm3: "" } },
                        [
                          _c("v-combobox", {
                            attrs: {
                              disabled: _vm.disabledForm || _vm.deshabilitar,
                              items: _vm.modalityList,
                              label: "Modalidad",
                              "item-text": "nombre",
                              "item-value": "id"
                            },
                            model: {
                              value: _vm.objParam.serieactivamodalidad,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.objParam,
                                  "serieactivamodalidad",
                                  $$v
                                )
                              },
                              expression: "objParam.serieactivamodalidad"
                            }
                          })
                        ],
                        1
                      ),
                      _vm.isEdit
                        ? _c(
                            "v-flex",
                            { attrs: { md3: "", sm3: "" } },
                            [
                              _c("v-checkbox", {
                                attrs: {
                                  disabled:
                                    _vm.disabledForm || _vm.deshabilitar,
                                  label: "Cambio Batería"
                                },
                                on: { change: _vm.handleBateriaSelected },
                                model: {
                                  value: _vm.objParam.bateria,
                                  callback: function($$v) {
                                    _vm.$set(_vm.objParam, "bateria", $$v)
                                  },
                                  expression: "objParam.bateria"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.isEdit
                        ? _c(
                            "v-flex",
                            { attrs: { md3: "", sm3: "" } },
                            [
                              _c("DatePicker", {
                                attrs: {
                                  disabled:
                                    _vm.deshabilitar ||
                                    _vm.disabledFiled.bateria ||
                                    _vm.disabledForm,
                                  label: "Fecha Cambio Batería"
                                },
                                model: {
                                  value: _vm.objParam.fecha_bateria,
                                  callback: function($$v) {
                                    _vm.$set(_vm.objParam, "fecha_bateria", $$v)
                                  },
                                  expression: "objParam.fecha_bateria"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "v-flex",
                        { attrs: { md3: "", sm3: "" } },
                        [
                          _c("v-combobox", {
                            attrs: {
                              disabled: _vm.disabledForm || _vm.deshabilitar,
                              items: _vm.avlList,
                              label: "Plataforma",
                              "item-text": "nombre",
                              "item-value": "id"
                            },
                            model: {
                              value: _vm.objParam.serieactivaplataforma,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.objParam,
                                  "serieactivaplataforma",
                                  $$v
                                )
                              },
                              expression: "objParam.serieactivaplataforma"
                            }
                          })
                        ],
                        1
                      ),
                      _vm.isEdit
                        ? _c(
                            "v-flex",
                            { attrs: { md3: "", sm3: "" } },
                            [
                              _c("v-checkbox", {
                                attrs: {
                                  disabled:
                                    _vm.disabledForm || _vm.deshabilitar,
                                  label: "Registro en Plataforma"
                                },
                                on: { change: _vm.handleFechaPlataforma },
                                model: {
                                  value: _vm.objParam.plataforma_ingresada,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.objParam,
                                      "plataforma_ingresada",
                                      $$v
                                    )
                                  },
                                  expression: "objParam.plataforma_ingresada"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.isEdit
                        ? _c(
                            "v-flex",
                            { attrs: { md3: "", sm3: "" } },
                            [
                              _c("DatePicker", {
                                attrs: {
                                  disabled:
                                    _vm.disabledForm ||
                                    _vm.deshabilitar ||
                                    _vm.disabledFiled.plataformDate,
                                  label: "Fecha Plataforma"
                                },
                                model: {
                                  value: _vm.objParam.serieactivaplata_fecha,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.objParam,
                                      "serieactivaplata_fecha",
                                      $$v
                                    )
                                  },
                                  expression: "objParam.serieactivaplata_fecha"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.isEdit
                        ? _c(
                            "v-flex",
                            { attrs: { md3: "", sm3: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  disabled:
                                    _vm.disabledForm || _vm.deshabilitar,
                                  label: "ID Plataforma"
                                },
                                model: {
                                  value: _vm.objParam.serieactivaid_dispositivo,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.objParam,
                                      "serieactivaid_dispositivo",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "objParam.serieactivaid_dispositivo"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.isEdit
                        ? _c(
                            "v-flex",
                            { attrs: { md3: "", sm3: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  disabled:
                                    _vm.disabledForm || _vm.deshabilitar,
                                  label: "AVL"
                                },
                                model: {
                                  value: _vm.objParam.serieactivaavl,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.objParam,
                                      "serieactivaavl",
                                      $$v
                                    )
                                  },
                                  expression: "objParam.serieactivaavl"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "v-flex",
                        { attrs: { md3: "", sm3: "" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              disabled: _vm.disabledForm || _vm.deshabilitar,
                              label: "EPC"
                            },
                            model: {
                              value: _vm.objParam.epc,
                              callback: function($$v) {
                                _vm.$set(_vm.objParam, "epc", $$v)
                              },
                              expression: "objParam.epc"
                            }
                          })
                        ],
                        1
                      ),
                      _vm.isEdit
                        ? _c(
                            "v-flex",
                            { attrs: { md3: "", sm3: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  disabled:
                                    _vm.disabledForm || _vm.deshabilitar,
                                  label: "IMEI"
                                },
                                model: {
                                  value: _vm.objParam.serieimei,
                                  callback: function($$v) {
                                    _vm.$set(_vm.objParam, "serieimei", $$v)
                                  },
                                  expression: "objParam.serieimei"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.isEdit
                        ? _c(
                            "v-flex",
                            { attrs: { md3: "", sm3: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  disabled:
                                    _vm.disabledForm || _vm.deshabilitar,
                                  label: "SIM Número"
                                },
                                model: {
                                  value: _vm.objParam.simserienumero,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.objParam,
                                      "simserienumero",
                                      $$v
                                    )
                                  },
                                  expression: "objParam.simserienumero"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.isEdit
                        ? _c(
                            "v-flex",
                            { attrs: { md2: "", sm2: "", xs2: "" } },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "padding-top": "6px",
                                    "padding-right": "0px"
                                  },
                                  attrs: { align: "right" }
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticStyle: {
                                        "padding-right": "20px",
                                        "background-color": "#27488e!important",
                                        width: "135px"
                                      },
                                      attrs: {
                                        disabled:
                                          _vm.disabledForm ||
                                          _vm.deshabilitar ||
                                          _vm.disabledFiled.btnSave
                                      },
                                      on: { click: _vm.getEstadoSim }
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticStyle: { color: "white" },
                                          attrs: { dark: "", left: "" }
                                        },
                                        [_vm._v("sync")]
                                      ),
                                      _c(
                                        "span",
                                        { staticStyle: { color: "white" } },
                                        [_vm._v("Validar Sim")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm.isEdit
                        ? _c(
                            "v-flex",
                            { attrs: { md3: "", sm3: "" } },
                            [
                              _c("v-text-field", {
                                attrs: { label: "Estado SIM", disabled: "" },
                                model: {
                                  value: _vm.objParam.estado,
                                  callback: function($$v) {
                                    _vm.$set(_vm.objParam, "estado", $$v)
                                  },
                                  expression: "objParam.estado"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.isEdit
                        ? _c(
                            "v-flex",
                            { attrs: { md3: "", sm3: "" } },
                            [
                              _c("v-text-field", {
                                attrs: { label: "Número SIM", disabled: "" },
                                model: {
                                  value: _vm.objParam.simmovil,
                                  callback: function($$v) {
                                    _vm.$set(_vm.objParam, "simmovil", $$v)
                                  },
                                  expression: "objParam.simmovil"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.isEdit
                        ? _c(
                            "v-flex",
                            { attrs: { md3: "", sm3: "" } },
                            [
                              _c("v-text-field", {
                                attrs: { label: "Telco", disabled: "" },
                                model: {
                                  value: _vm.objParam.telconame,
                                  callback: function($$v) {
                                    _vm.$set(_vm.objParam, "telconame", $$v)
                                  },
                                  expression: "objParam.telconame"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "v-flex",
                        { attrs: { sm12: "" } },
                        [
                          _c("v-textarea", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "max:350",
                                expression: "'max:350'"
                              }
                            ],
                            attrs: {
                              label: "Observación",
                              counter: 350,
                              disabled: _vm.disabledForm || _vm.deshabilitar,
                              rules: [_vm.rules.counter],
                              "model-value": _vm.objParam.serieactivaobs
                            },
                            model: {
                              value: _vm.objParam.serieactivaobs,
                              callback: function($$v) {
                                _vm.$set(_vm.objParam, "serieactivaobs", $$v)
                              },
                              expression: "objParam.serieactivaobs"
                            }
                          })
                        ],
                        1
                      ),
                      _vm.isEdit
                        ? _c(
                            "v-flex",
                            { attrs: { sm12: "" } },
                            [
                              _c("v-checkbox", {
                                attrs: {
                                  disabled:
                                    _vm.disabledForm || _vm.deshabilitar,
                                  label: "Registro Validado"
                                },
                                model: {
                                  value: _vm.objParam.validauser,
                                  callback: function($$v) {
                                    _vm.$set(_vm.objParam, "validauser", $$v)
                                  },
                                  expression: "objParam.validauser"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c("v-flex", { attrs: { md12: "", sm12: "" } }, [
            _c("div", { staticClass: "text-sm-center layout" }, [
              _c(
                "div",
                {
                  staticStyle: { "padding-top": "6px", "padding-right": "0px" },
                  attrs: { align: "right" }
                },
                [
                  _c(
                    "v-btn",
                    {
                      staticStyle: {
                        "padding-right": "20px",
                        "background-color": "#ff6c00!important",
                        width: "135px"
                      },
                      attrs: {
                        disabled:
                          _vm.disabledForm ||
                          _vm.deshabilitar ||
                          _vm.disabledFiled.btnSave
                      },
                      on: { click: _vm.handleEdit }
                    },
                    [
                      _c(
                        "v-icon",
                        {
                          staticStyle: { color: "white" },
                          attrs: { dark: "", left: "" }
                        },
                        [_vm._v("save")]
                      ),
                      _c("span", { staticStyle: { color: "white" } }, [
                        _vm._v("Guardar")
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: { "padding-top": "6px", "padding-right": "0px" },
                  attrs: { align: "right" }
                },
                [
                  _c(
                    "v-btn",
                    {
                      staticStyle: {
                        "padding-right": "20px",
                        color: "#27488e!important",
                        width: "135px"
                      },
                      on: {
                        click: function($event) {
                          return _vm.closeModal({})
                        }
                      }
                    },
                    [
                      _c(
                        "v-icon",
                        {
                          staticStyle: { color: "black" },
                          attrs: { dark: "", left: "" }
                        },
                        [_vm._v("undo")]
                      ),
                      _c("span", { staticStyle: { color: "black" } }, [
                        _vm._v("Volver")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ]),
          _c("div", { staticClass: "clearfix", staticStyle: { width: "100%" } })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }